import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './common/token-interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule  } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { DatePipe } from '@angular/common';
import { HomeModule } from './home';
import { AppComponent } from './app.component';
import { AppRoutes } from './app.routes';
import { LandingScreenComponent } from './landing-screen';
import { ApportisCommonModule } from './common';
import { NotifierModule, NotifierOptions } from 'angular-notifier';
import { CheckBoxModule, ButtonModule } from '@syncfusion/ej2-angular-buttons';
import { NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { MultiSelectAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { ThemeModule } from './theme/theme.module';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatRadioModule} from '@angular/material/radio';
import { AvatarModule } from 'ngx-avatar';
import { NgxTimerModule } from 'ngx-timer';
import { PatientService } from './patient/patient.service';
import { TokboxService } from './video/tokbox/tokbox-viewer/tokbox.service';
import { DocumentViewComponent } from './document-view/document-view.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { ImageViewerModule } from 'ngx-image-viewer';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { InternalErrorComponent } from './internal-error/internal-error.component';
import { NgxSpinnerModule } from 'ngx-spinner';


const customNotifierOptions: NotifierOptions = {
  position: {
        horizontal: {
            position: 'right',
            distance: 12
        },
        vertical: {
            position: 'top',
            distance: 12,
            gap: 10
        }
    },
  theme: 'material',
  behaviour: {
    autoHide: 10000,
    onClick: 'hide',
    onMouseover: 'pauseAutoHide',
    showDismissButton: true,
    stacking: 4
  },
  animations: {
    enabled: true,
    show: {
      preset: 'slide',
      speed: 300,
      easing: 'ease'
    },
    hide: {
      preset: 'fade',
      speed: 300,
      easing: 'ease',
      offset: 50
    },
    shift: {
      speed: 300,
      easing: 'ease'
    },
    overlap: 150
  }
};


@NgModule({
  declarations: [
    AppComponent,
    LandingScreenComponent,
    DocumentViewComponent,
    PageNotFoundComponent,
    UnauthorizedComponent,
    InternalErrorComponent,
    

 ],
  imports: [
    HomeModule,
    ApportisCommonModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatTableModule,
    MatIconModule,
    MatExpansionModule,
    MatSidenavModule,
    BrowserModule,
    MatRadioModule,
    MatDividerModule,
    NgxTimerModule,
    RouterModule.forRoot(AppRoutes, {
      onSameUrlNavigation: 'reload'
    }),
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    BrowserAnimationsModule,
    NotifierModule.withConfig(customNotifierOptions),
    ThemeModule,
    MatFormFieldModule,
    AvatarModule,
    NgxDocViewerModule,
    ImageViewerModule.forRoot()
 ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    [DatePipe],
    PatientService,
    TokboxService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
